import { MenuConfig } from '../brand.interface';

/**
 * DeleteMe Menu Configuration
 * Full menu with all features enabled
 */
export const deletemeMenu: MenuConfig = {
  items: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: 'pi pi-home',
      routerLink: '/dashboard',
      visible: true,
    },
    {
      id: 'privacy-quiz',
      label: 'Privacy Quiz',
      icon: 'pi pi-shield',
      routerLink: '/privacy-check',
      visible: true,
    },
    {
      id: 'data-brokers',
      label: 'Data Brokers',
      icon: 'pi pi-database',
      routerLink: '/removals/data-brokers',
      visible: true,
      featureFlag: 'dataBrokerRemovals',
    },
    {
      id: 'removal-requests',
      label: 'Removal Requests',
      icon: 'pi pi-user-minus',
      visible: true,
      children: [
        {
          id: 'data-breach-subscription',
          label: 'Data Breach',
          icon: '',
          routerLink: '/removals/data-breach-subscription',
          visible: true,
          featureFlag: 'dataBreachSubscription',
        },
        {
          id: 'search-engine',
          label: 'Search Engine',
          icon: '',
          routerLink: '/removals/search-engine',
          visible: true,
          featureFlag: 'searchEngineRemovals',
        },
        {
          id: 'custom-removal',
          label: 'Custom Removal',
          icon: '',
          routerLink: '/removals/custom-removal',
          visible: true,
          featureFlag: 'customRemovals',
        },
        {
          id: 'doxbin',
          label: 'Doxbin',
          icon: '',
          routerLink: '/removals/doxbin',
          visible: false,
          featureFlag: 'doxbinRemovals',
        },
        {
          id: 'kyc',
          label: 'KYC',
          icon: '',
          routerLink: '/removals/kyc',
          visible: false,
          featureFlag: 'kycRemovals',
        },
      ],
    },
    {
      id: 'scans',
      label: 'Scans & Reports',
      icon: 'pi pi-search',
      routerLink: '/reports',
      visible: true,
    },
    {
      id: 'alert-subscriptions',
      label: 'Alerts',
      icon: 'pi pi-bell',
      routerLink: '/reports/alert-subscriptions',
      visible: true,
      featureFlag: 'alertSubscriptions',
    },
    {
      id: 'rewards',
      label: 'Deals',
      icon: 'pi pi-gift',
      routerLink: '/rewards',
      visible: true,
    },
    {
      id: 'billing',
      label: 'Billing',
      icon: 'pi pi-credit-card',
      routerLink: '/billing',
      visible: true,
      featureFlag: 'billing',
    },
    {
      id: 'account',
      label: 'Account',
      icon: 'pi pi-user',
      routerLink: '/profile',
      visible: true,
    },
    {
      id: 'contact-us',
      label: 'Contact Us',
      icon: 'pi pi-envelope',
      routerLink: '/contact-us',
      visible: true,
      featureFlag: 'contactUs',
    },
    {
      id: 'privacy-center',
      label: 'Data Privacy Center',
      icon: 'pi pi-shield',
      externalUrl: 'https://privacy.deleteme.com',
      visible: true,
      featureFlag: 'privacyCenter',
    },
  ],
};
